import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllRadioButton, BllRadioGroup } from './radio.component';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';

@NgModule({
  imports: [CommonModule],
  declarations: [BllRadioButton, BllRadioGroup],
  exports: [BllRadioButton, BllRadioGroup],
  providers: [UniqueSelectionDispatcher],
})
export class BllRadioModule {}
